//
//
//
//
//
//
//
//
//

export default {
  name: 'ProductContributor',
  components: {
    ArtistAvatar: () => import('@motionelements/core/src/components/member/ArtistAvatar.vue'),
  },
  props: {
    contributor: {
      type: Object,
      required: true,
    },
  },
};
